import { Outlet } from 'react-router-dom';
import { SubHeader } from '../Accounts/SubHeader';
import './Group.less';

export const Group = () => {
  return (
    <div className="group-container account-container">
      <SubHeader />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};
